'use client';
import { jsx as r, jsxs as m } from "react/jsx-runtime";
import * as s from "@radix-ui/react-tabs";
import { createContext as h, useInheritDocDirection as C, cn as f } from "@tameeni/shared-logic";
import * as c from "react";
import { ScrollArea as x, ScrollBar as R } from "../scroll-area/scroll-area.js";
import { tabsStyles as d } from "./tabs.variants.js";
const [v, p] = h({
  name: "TabsContext"
}), w = c.forwardRef(({ variant: n = "solid", dir: e, className: t, locale: a, ...o }, l) => {
  const { direction: i } = C({ locale: a });
  return /* @__PURE__ */ r(v, { value: { variant: n, locale: a }, children: /* @__PURE__ */ r(
    s.Root,
    {
      ref: l,
      className: t,
      dir: e || i,
      ...o
    }
  ) });
});
w.displayName = s.Root.displayName;
const S = c.forwardRef(({ className: n, isCentered: e, ...t }, a) => {
  const { variant: o, locale: l } = p(), { list: i } = d({ variant: o });
  return e ? /* @__PURE__ */ r(
    s.List,
    {
      ref: a,
      className: f(i({ className: n }), "mx-auto"),
      ...t
    }
  ) : /* @__PURE__ */ m(x, { locale: l, className: "w-full", children: [
    /* @__PURE__ */ r(
      s.List,
      {
        ref: a,
        className: i({ className: n }),
        ...t
      }
    ),
    /* @__PURE__ */ r(R, { orientation: "horizontal" })
  ] });
});
S.displayName = s.List.displayName;
const L = c.forwardRef(({ className: n, icon: e, subTitle: t, children: a, asChild: o, ...l }, i) => {
  const { variant: N } = p(), { trigger: y, subTitleStyles: T, childrenStyles: b, labelContainer: u } = d({
    variant: N,
    icon: !!e,
    subTitle: !!t,
    children: !!a
  }), g = o ? "span" : c.Fragment;
  return /* @__PURE__ */ r(
    s.Trigger,
    {
      ref: i,
      className: y({ className: n }),
      ...l,
      children: /* @__PURE__ */ m(g, { children: [
        e && e,
        /* @__PURE__ */ m("span", { className: u(), children: [
          /* @__PURE__ */ r("span", { className: b(), children: a }),
          t && /* @__PURE__ */ r("span", { className: T(), children: t })
        ] })
      ] })
    }
  );
});
L.displayName = s.Trigger.displayName;
const j = c.forwardRef(({ className: n, ...e }, t) => {
  const { variant: a } = p(), { content: o } = d({ variant: a });
  return /* @__PURE__ */ r(
    s.Content,
    {
      ref: t,
      className: f(o(), n),
      ...e
    }
  );
});
j.displayName = s.Content.displayName;
export {
  w as Tabs,
  j as TabsContent,
  S as TabsList,
  L as TabsTrigger
};
